query PlatformsAutocomplete(
  $input: String
  $value: [ID!]
  $filter: PlatformsFilterInput
) {
  autocomplete: autocompletePlatforms(
    input: $input
    value: $value
    filter: $filter
  ) {
    value {
      label
      value
    }
    options {
      label
      value
    }
  }
}
